import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';

/**
 * Create a new Choices instance with default configuration
 * @param {HTMLElement} element - The select element to initialize Choices on
 * @param {Object} [customOptions={}] - Custom options to override defaults
 * @returns {Choices} The initialized Choices instance
 */
export function createChoices(element, customOptions = {}) {
    const defaultOptions = {
        removeItemButton: true,
        placeholder: true,
        placeholderValue: getMessage("kibe.core.choice.placeholder"),
        searchPlaceholderValue: getMessage("kibe.core.choice.searchPlaceholderValue"),
        shouldSort: false,
        shadowRoot: element.getRootNode(),
        allowHTML: false
    };

    return new Choices(element, { ...defaultOptions, ...customOptions });
}

// Choices Component
export default (options = {}) => ({
    choicesInstance: [],
    init() {

        // Add placeholder option if not multiple and none exists
        if (!this.$el.multiple && !this.$el.querySelector('option[placeholder]')) {
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.setAttribute('placeholder', '');
            placeholder.selected = !this.$el.querySelector('option[selected]');
            this.$el.insertBefore(placeholder, this.$el.firstChild);
        }

        this.choicesInstance = createChoices(this.$el, options);
    },
    destroy() {
        this.choicesInstance?.destroy()
    }
});
